<div class="who-we-are-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>{{ 'vision.title' | translate }} <span>{{ 'vision.highlight' | translate }}</span></h2>

        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-who-we-are">
                    <i class="fa fa-eye"></i>
                    <h3>{{ 'vision.visionTitle' | translate }}</h3>
                    <p>{{ 'vision.visionText' | translate }}</p>
                    <span>1</span>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-who-we-are">
                    <i class="fa-solid fa-bullseye"></i>
                    <h3>{{ 'vision.missionTitle' | translate }}</h3>
                    <p>{{ 'vision.missionText' | translate }}</p>
                    <span>2</span>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-who-we-are">
                    <i class="fa-regular fa-heart"></i>
                    <h3>{{ 'vision.valuesTitle' | translate }}</h3>
                        <ul class="features-list">
                            <li><i class="fa fa-check"></i>{{ 'vision.honesty' | translate }}</li>
                            <li><i class="fa fa-check"></i>{{ 'vision.transparency' | translate }}</li>
                            <li><i class="fa fa-check"></i>{{ 'vision.professionalism' | translate }}</li>
                            <li><i class="fa fa-check"></i>{{ 'vision.ethics' | translate }}</li>
                            <li><i class="fa fa-check"></i>{{ 'vision.dedication' | translate }}</li>
                        </ul>
                    <span>3</span>
                </div>
            </div>
        </div>
    </div>
</div>
